import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/KER_APP_OKRChecker-8.png'
import _imports_1 from '../assets/okr_checker_heading.png'
import _imports_2 from '../assets/Wortmarke_Schwarz@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-6f173c3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row align-items-stretch vh-100" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 text-center d-none d-md-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "OKR Logo",
    class: "img-fluid"
  })
], -1))
const _hoisted_4 = { class: "col-md-6 d-flex align-items-center justify-content-center" }
const _hoisted_5 = { class: "width-form" }
const _hoisted_6 = { class: "c d-flex flex-column justify-content-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "OKR Logo",
    class: "mb-3 heading-img"
  })
], -1))
const _hoisted_8 = { class: "card" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "div mt-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-center" }, "Hier Registrieren")
], -1))
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "E-Mail:", -1))
const _hoisted_12 = {
  key: 0,
  class: "error"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Passwort:", -1))
const _hoisted_14 = {
  key: 1,
  class: "error"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "confirm_password" }, "Passwort wiederholen:", -1))
const _hoisted_16 = {
  key: 2,
  class: "error"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "form-check" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "privacy_policy"
}, [
  /*#__PURE__*/_createTextVNode(" Ich akzeptiere die "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://keravonos.de/datenschutz",
    target: "_blank"
  }, "Datenschutzerklärung"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_20 = { class: "form-check" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "info_emails"
}, " Ich möchte über Neuigkeiten und Updates informiert werden. ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  value: "Benutzer Registrieren",
  class: "btn btn-primary"
}, null, -1))
const _hoisted_24 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_25 = { class: "text-center mt-4 mb-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://keravonos.de" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Logo",
    width: "120"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("form", {
                    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"])),
                    class: "form-group"
                  }, [
                    _hoisted_11,
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      id: "email",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                      class: "form-control",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.email]
                    ]),
                    (_ctx.errors.email)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.errors.email[0]), 1))
                      : _createCommentVNode("", true),
                    _hoisted_13,
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      id: "password",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                      class: "form-control",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.password]
                    ]),
                    (_ctx.errors.password)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.errors.password[0]), 1))
                      : _createCommentVNode("", true),
                    _hoisted_15,
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      id: "confirm_password",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirm_password) = $event)),
                      class: "form-control",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.confirm_password]
                    ]),
                    (_ctx.errors.confirm_password)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.errors.confirm_password[0]), 1))
                      : _createCommentVNode("", true),
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "privacy_policy",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.privacy_policy) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.privacy_policy]
                      ]),
                      _hoisted_19
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "info_emails",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.info_emails) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.info_emails]
                      ]),
                      _hoisted_21
                    ]),
                    _hoisted_22,
                    _hoisted_23
                  ], 32),
                  (_ctx.message)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createTextVNode(_toDisplayString(_ctx.message) + " ", 1),
                        _createVNode(_component_RouterLink, { to: "/login" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Hier einloggen")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_25, [
      _createElementVNode("p", null, [
        _createTextVNode(" Made with "),
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'heart'],
          class: "heart"
        }),
        _createTextVNode(" by "),
        _hoisted_26
      ])
    ])
  ], 64))
}